import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';
import { Typography } from '@material-ui/core';

class IRIgeneration extends React.Component {

    render() {

        const { classes, iriFormat, onChange, margin, disabled, allowCounter, handlePrimaryChange, handleSecondaryChange,
            primaryCounter, secondaryCounter, showCounters, showSecondaryCounter } = this.props;

        return (
            <TitledPanel dataTest="iri-generation" title="IRI Format" margin={margin}>
                <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                    <legend className={classes.hideLegend}>IRI format</legend>
                    <RadioGroup row aria-label="IRI format" name="iriFormat" value={iriFormat} onChange={onChange}>
                        <FormControlLabel
                            data-test="select-uuid"
                            disabled={disabled}
                            value="UUID"
                            control={<Radio color="primary" />}
                            label="UUID"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel
                            data-test="select-label"
                            disabled={disabled}
                            value="Label"
                            control={<Radio color="primary" />}
                            label="Label"
                            classes={{ label: classes.formLabelInline }}
                        />
                        {allowCounter &&
                            <FormControlLabel
                                data-test="select-counter"
                                disabled={disabled}
                                value="Counter"
                                control={<Radio color="primary" />}
                                label="Counter"
                                classes={{ label: classes.formLabelInline }}
                            />
                        }
                    </RadioGroup>
                    {showCounters &&
                        <div style={{ border: 'solid 1px #c0c0c0', borderRadius: 4, marginTop: 6, padding: 6, marginBottom: 6 }}>
                            <div data-test="counters" style={{ display: 'flex' }}>
                                <div>
                                    <TextField
                                        onChange={handlePrimaryChange}
                                        InputProps={{
                                            inputProps: {
                                                "aria-label": "Primary counter",
                                                "data-test": "primary-counter",
                                                "min": 1,
                                                "max": 10000000000
                                            },
                                            className: classes.inputLabel
                                        }}
                                        label="Primary"
                                        variant="outlined"
                                        type="number"
                                        margin="dense"
                                        value={primaryCounter} />
                                </div>
                                {showSecondaryCounter &&
                                    <div style={{ marginLeft: 12 }}>
                                        <TextField
                                            onChange={handleSecondaryChange}
                                            InputProps={{
                                                inputProps: {
                                                    "aria-label": "Secondary counter",
                                                    "data-test": "secondary-counter",
                                                    "min": 1000,
                                                    "max": 10000000000
                                                },
                                                className: classes.inputLabel
                                            }}
                                            label="Secondary"
                                            error={secondaryCounter <= primaryCounter + 10000}
                                            variant="outlined"
                                            margin="dense"
                                            type="number"
                                            value={secondaryCounter} />
                                    </div>
                                }
                            </div>
                            {showSecondaryCounter &&
                                <Typography variant="caption">It is vital that you leave enough gap between counters to allow for the maximum number of concepts.</Typography>
                            }
                        </div>
                    }
                </FormControl>
            </TitledPanel>
        );
    }
}

IRIgeneration.defaultProps = {
    margin: true,
    disabled: false,
    showCounters: false,
    primaryCounter: 1,
    secondaryCounter: 1000,
    allowCounter: false
};

IRIgeneration.propTypes = {
    disabled: PropTypes.bool,
    iriFormat: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    primaryCounter: PropTypes.number,
    secondaryCounter: PropTypes.number,
    showSecondaryCounter: PropTypes.bool,
    allowCounter: PropTypes.bool,
    margin: PropTypes.bool
};

export default withStyles(styles)(IRIgeneration);